import { UpsertUserModal } from '../UpsertUser/UpsertUserModal'
import { createCreateButton } from '../../../../components/CreateButton'
import translations from '../Actions.i18n.json'

export const UserCreateButton = createCreateButton({
  UpsertModal: UpsertUserModal,
  translations,
})
